import * as ws_base from '../ws/ws_base'


const DOMINIO = "enderecos";



export async function novoEndereco(endereco){

	return await ws_base.post(DOMINIO, "novo", endereco);
}


export async function excluirEndereco(id_endereco){
	
	return await ws_base.get(DOMINIO, "remover", {"id_endereco": id_endereco});
}


export async function buscarEnderecos(id_usuario){

	return await ws_base.post(DOMINIO, "obter", {"id_usuario": id_usuario});
}


export async function buscarCidades(uf){

	return await ws_base.get(DOMINIO, "obter_cidades", {"uf": uf});
}